import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Download a ledger file
 * @param {string} filePath - The file path from ledgerList
 * @returns {Promise<{success: boolean, message?: string, error?: any}>}
 */
export const downloadLedgerAction = async (filePath) => {
  try {
    if (!filePath) {
      return {
        success: false,
        message: "File path is required",
      };
    }

    // Make GET request with filePath as query parameter
    const response = await apiClient.get(
      `${ATP_API_URL.DOWNLOAD_LEDGER}?filePath=${encodeURIComponent(filePath)}`,
      {
        responseType: "blob", // Important for file downloads
      },
    );

    if (response?.status === 200 && response.data) {
      // Extract filename from filePath (after the last backslash)
      const fileName = filePath.split("\\").pop() || "ledger-file.xlsx";

      // Create a blob URL and trigger download
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: "File downloaded successfully",
      };
    }

    return {
      success: false,
      message: "Failed to download file",
    };
  } catch (error) {
    console.error("[DownloadLedger] error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message || error.message || "Download failed",
      error,
    };
  }
};
